/**
 * How a list's values are written as pill text and read back from typed text.
 * `parse` returns `undefined` for text that is not a value, which the field
 * then refuses to commit.
 */
export interface ListValueCodec<T> {
  parse: (text: string) => T | undefined;
  format: (value: T) => string;
}

/** Any text is a value, as typed. */
export const stringValueCodec: ListValueCodec<string> = {
  parse: (text) => text,
  format: (value) => value,
};

/**
 * Finite numbers only: `Infinity`, `NaN` and text that isn't a number are
 * refused. Written back in JavaScript's shortest form, so "3.0" and "3" are
 * one value.
 */
export const numericValueCodec: ListValueCodec<number> = {
  parse: (text) => {
    const trimmed = text.trim();
    if (trimmed === "") {
      return undefined;
    }
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : undefined;
  },
  format: (value) => value.toString(),
};
